<template>
  <PasswordComponent modo="olvido" />
</template>

<script>
import PasswordComponent from "@/components/PasswordComponent.vue";
export default {
  components: { PasswordComponent },
}
</script>
